"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftRewardPrizeEmailToJSON = exports.NftRewardPrizeEmailFromJSONTyped = exports.NftRewardPrizeEmailFromJSON = void 0;
function NftRewardPrizeEmailFromJSON(json) {
    return NftRewardPrizeEmailFromJSONTyped(json, false);
}
exports.NftRewardPrizeEmailFromJSON = NftRewardPrizeEmailFromJSON;
function NftRewardPrizeEmailFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subject': json['subject'],
        'body': json['body'],
        'docAttachments': json['docAttachments'],
        'imageAttachments': json['imageAttachments'],
    };
}
exports.NftRewardPrizeEmailFromJSONTyped = NftRewardPrizeEmailFromJSONTyped;
function NftRewardPrizeEmailToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subject': value.subject,
        'body': value.body,
        'docAttachments': value.docAttachments,
        'imageAttachments': value.imageAttachments,
    };
}
exports.NftRewardPrizeEmailToJSON = NftRewardPrizeEmailToJSON;
